export default (mutation) => {
  const linksToPreserveUTM = [
    '.preserve-utms a'
  ];

  if (mutation.type !== 'childList' || !mutation.target.matches(linksToPreserveUTM.join(',') || !mutation.target.href)) {
    return;
  }

  const utmParametersToPreserve = ['utm_medium', 'utm_campaign', 'utm_source', 'utm_term', 'utm_content'];
  const queryIn = new URLSearchParams(window.location.search);
  const url = new URL(mutation.target.href);

  for (const [parameter, value] of queryIn) {
    if (!url.searchParams.has(parameter) && utmParametersToPreserve.indexOf(parameter) !== -1) {
      url.searchParams.set(parameter, value);
    }
  }

  mutation.target.href = url;
};
